import type { LibraryPhoto, Manifest } from './types';

type ApiError = { error?: string };

async function parse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as ApiError;
    throw new Error(body.error || `Request failed (${response.status})`);
  }
  return response.json() as Promise<T>;
}

export async function getManifest(): Promise<Manifest> {
  return parse<Manifest>(await fetch('/api/mockup/manifest', { cache: 'no-store' }));
}

export async function saveManifest(manifest: Manifest): Promise<Manifest> {
  return parse<Manifest>(await fetch('/api/mockup/manifest', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(manifest),
  }));
}

export async function uploadPhoto(file: File, id: string, name: string, width: number, height: number): Promise<LibraryPhoto> {
  return parse<LibraryPhoto>(await fetch('/api/mockup/photos', {
    method: 'POST',
    headers: {
      'Content-Type': file.type,
      'X-Photo-Id': id,
      'X-Photo-Name': encodeURIComponent(name),
      'X-Photo-Width': String(width),
      'X-Photo-Height': String(height),
    },
    body: file,
  }));
}

export async function deletePhoto(id: string): Promise<void> {
  const response = await fetch(`/api/mockup/photos/${encodeURIComponent(id)}`, { method: 'DELETE' });
  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as ApiError;
    throw new Error(body.error || `Delete failed (${response.status})`);
  }
}

export function photoUrl(photo: LibraryPhoto): string {
  return `/api/mockup/photos/${encodeURIComponent(photo.id)}${photo.mediaType === 'video' ? '?poster=1' : ''}`;
}
